import { ApiDateSchema, REPORT_JOB_TYPES } from '@weft/types';
import { oz } from '@weft/utils';

export const TriggerCommitmentUsageReportJobParametersSchema = oz.object({
  reportJobType: oz.literal(REPORT_JOB_TYPES.CommitmentUsage),
  reportName: oz.string().optional(),
  upToDate: ApiDateSchema,
  startDate: ApiDateSchema.optional(),
});

export type TriggerCommitmentUsageReportJobParameters = oz.TypeOf<typeof TriggerCommitmentUsageReportJobParametersSchema>;